export default __webpack_public_path__ + "static/2-4a6f0c44c34796ce3057cfb81926ff76.jpeg";